/* import __COLOCATED_TEMPLATE__ from './usage-in-subscription.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { type TooltipRow } from 'embercom/components/billing/usage/tooltips-new/shared-components/tooltip-item';

interface Args {
  allowanceForBillingPeriod: number;
  dataTestId?: string;
}

export default class UsageInSubscription extends Component<Args> {
  @service declare intl: IntlService;

  get usageInSubscriptionRow() {
    let res = [
      {
        label: this.intl.t('billing.summary.usage-tooltip.usage_in_subscription'),
        muted: true,
        noPadding: true,
        strong: true,
      },
      { label: `${this.args.allowanceForBillingPeriod}` },
    ];
    return res as TooltipRow[];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Usage::TooltipsNew::SharedComponents::UsageInSubscription': typeof UsageInSubscription;
  }
}
